import type { ProductClassificationResponse } from '@brickup/shared/dto'
import type { ProductClassificationKind } from '@brickup/shared/enums'

/** One of the four lists, in the order an admin put it in. */
export const classificationEntriesOfKind = (
  entries: readonly ProductClassificationResponse[],
  kind: ProductClassificationKind,
) => entries.filter(entry => entry.kind === kind)

/** The same list as a dropdown's options, without the leading empty or "all"
 *  entry — a select and a filter disagree about what that one means. */
export const classificationOptions = (
  entries: readonly ProductClassificationResponse[],
  kind: ProductClassificationKind,
) =>
  classificationEntriesOfKind(entries, kind).map(entry => ({
    value: String(entry.id),
    label: entry.name,
  }))
